/** Home / quick start. */
const dictionary = {
  "en": {
    "quickStartTitle": "Welcome",
    "quickStartGuide": "Your quick start guide",
    "steps": {
      "manageCompanyProfile": "Update your company details",
      "manageCorporateUsers": "Invite, review and edit all corporate users",
      "manageUserRoles": "Review user roles and permissions",
      "viewCompanyProfile": "View your company and account profile",
      "createTeam": "Create your team and invite",
      "auditTeam": "Audit your team",
      "createPosition": "Create an open position"
    },
    "welcome": "Welcome {name}",
    "companyNameFallback": "Your company name"
  },
  "de": {
    "quickStartTitle": "Willkommen",
    "quickStartGuide": "Die wichtigsten Funktionen auf einen Blick",
    "steps": {
      "manageCompanyProfile": "Unternehmensdaten aktualisieren",
      "manageCorporateUsers": "Alle Unternehmensnutzer einladen, prüfen und bearbeiten",
      "manageUserRoles": "Nutzerrollen und Berechtigungen prüfen",
      "viewCompanyProfile": "Unternehmens- und Kontoprofil ansehen",
      "createTeam": "Team erstellen und einladen",
      "auditTeam": "Team analysieren",
      "createPosition": "Offene Position erstellen"
    },
    "welcome": "Willkommen {name}",
    "companyNameFallback": "Ihr Unternehmensname"
  },
  "fi": {
    "quickStartTitle": "Tervetuloa",
    "quickStartGuide": "Pikaopas",
    "steps": {
      "manageCompanyProfile": "Päivitä yrityksesi tiedot",
      "manageCorporateUsers": "Kutsu, tarkista ja muokkaa kaikkia yrityskäyttäjiä",
      "manageUserRoles": "Tarkista käyttäjäroolit ja -oikeudet",
      "viewCompanyProfile": "Näytä yritys- ja tiliprofiilisi",
      "createTeam": "Luo tiimisi ja kutsu jäsenet",
      "auditTeam": "Kartoita tiimisi",
      "createPosition": "Luo avoin tehtävä"
    },
    "welcome": "Tervetuloa, {name}",
    "companyNameFallback": "Yrityksesi nimi"
  }
};

export default dictionary;
